module.exports = __webpack_public_path__ + "img/520a.35cd6515.png";